import React from 'react';
import { Col, Well, Row, ControlLabel } from 'react-bootstrap';

const AssigneeInfo = ({ assignee, assigneeGroup, details }) => (
    <Well>
        {details && (
            <Row>
                <Col componentClass={ControlLabel} sm={4}>
                    Assignee group
                </Col>
                <Col sm={8}>
                    {assigneeGroup &&
                        assigneeGroup.length > 0 &&
                        assigneeGroup.map((as, i) => (
                            <p key={as.name} title={as.name} className="text-ellipsis">
                                {as.name}
                                {i < assigneeGroup.length - 1 ? ',' : ''}
                            </p>
                        ))}
                    {assigneeGroup && assigneeGroup.length === 0 && '-'}
                </Col>
            </Row>
        )}
        <Row>
            <Col componentClass={ControlLabel} sm={4}>
                Assignee
            </Col>
            <Col sm={8}>{assignee || '-'}</Col>
        </Row>
    </Well>
);

export default AssigneeInfo;
